import { render } from "./BookingHistoryDashboard.vue?vue&type=template&id=44a4a7dc"
import script from "./BookingHistoryDashboard.vue?vue&type=script&lang=js"
export * from "./BookingHistoryDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__